/* eslint-disable no-restricted-imports */
import {
  GridApi,
  GridEventListener,
  GridRowHeightReturnValue,
  GridToolbarQuickFilter,
  GridValidRowModel,
  DataGrid as MuiDataGrid,
  DataGridProps as MuiDataGridProps,
} from '@mui/x-data-grid';
import { JSX, useRef } from 'react';

const getRowHeight = (): GridRowHeightReturnValue => 'auto';

export interface DataGridProps<R extends GridValidRowModel> extends MuiDataGridProps<R> {
  /**
   * Flag to enable quick filter (search)
   */
  enableQuickFilter?: boolean;
  /**
   * If false the actions will be visible all the time
   * @default true
   */
  actionsVisibleOnHover?: boolean;
}

/**
 * DataGrid wrapper with common props
 */
const DataGrid = <R extends GridValidRowModel>({
  sx,
  enableQuickFilter = true,
  actionsVisibleOnHover = true,
  ...props
}: DataGridProps<R>): JSX.Element => {
  const apiRef = useRef<GridApi>({} as GridApi);
  const handleCellClick: GridEventListener<'cellClick'> = ({ field, id }): void => {
    try {
      apiRef.current?.startCellEditMode({ id, field });
    } catch {
      // ignore error when clicking on non-editable cell
    }
  };

  return (
    <MuiDataGrid
      pagination
      autoHeight
      disableColumnMenu
      disableRowSelectionOnClick
      apiRef={apiRef}
      getRowHeight={getRowHeight}
      onCellClick={handleCellClick}
      sx={[
        !actionsVisibleOnHover && {
          '& .MuiDataGrid-actionsCell': {
            visibility: 'visible!important',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      showToolbar={enableQuickFilter}
      slotProps={{ toolbar: { className: 'quickFilter' } }}
      {...props}
    />
  );
};

export default DataGrid;
